import RichText from 'components/rich-text';
import dynamic from 'next/dynamic';

const Modal = dynamic(
  () => import('components/_shared/widgets/modal/with-close')
);

const CustomerLimitDisclaimerModal = ({
  close,
  isOpen,
  description,
}: {
  close: () => void;
  isOpen: boolean;
  description: string;
}) => (
  <Modal
    title="Purchase limit disclaimer"
    close={close}
    isOpen={isOpen}
    iconSize={20}
    size="tiny"
  >
    <RichText content={description} />
  </Modal>
);

export default CustomerLimitDisclaimerModal;
